import reducer from './reducers';

import * as analystActions from './actions';

export {
  analystActions,
};

export default reducer;
